<template>
    <component :placeholder="thumbnailSize === 'none' ? undefined : ImageService.getURL(url, thumbnailSize)"
               :src="ImageService.getURL(url, size)"
               :is="type ? 'progressive-background' : 'progressive-img'">
        <div slot="content">
            <slot name="content"></slot>
        </div>
    </component>
</template>

<script>
	import ImageService from "@/services/ImageService";

	export default {
		name: "ImageView",
		props: {
			"url": {
				type: String,
                required: true
            },
			"thumbnailSize": {
				type: String,
				required: false,
                default: "thumbnail"
			},
            "size": {
                type: String,
                required: true
            },
            "type": {
				type: String,
                required: false
            }
		},
		data() {
			return {
				ImageService: ImageService
			}
		}
	}
</script>

<style scoped>

</style>